import React from "react";

const TONES = {
  default: "bg-surface_alt text-text_secondary border-border",
  brand: "bg-primary_tint text-primary border-border",
  warning: "bg-warning_bg text-warning border-warning_border",
  danger: "bg-danger_bg text-danger border-danger_border",
  info: "bg-info_bg text-info border-info_border",
};

// Compact tag for counts and short facts ("12 fields", "list", "3 selected").
export default function Chip({ tone = "default", className = "", children }) {
  return (
    <span className={`inline-flex shrink-0 items-center whitespace-nowrap rounded-sm border px-1.5 py-px text-[10px] font-medium ${TONES[tone] || TONES.default} ${className}`}>
      {children}
    </span>
  );
}
